import React from 'react'
import { Row, Col } from 'reactstrap'
import context from '@/context'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { WhiteBox } from '@/components/Layout'
import { FormRow } from '@/components/changeRequests'
import { isNullOrWhiteSpace } from '@/utils/StringUtilities'

const PersonalData = ({ targetId, mode }) => {
  const [
    surname, fatherName, grandfatherName, greatGrandfatherName,
    motherName, motherFatherName, motherGrandfatherName
  ] = usePropertyReader([
    'surname', 'fatherName', 'grandfatherName', 'greatGrandfatherName',
    'motherName', 'motherFatherName', 'motherGrandfatherName'
  ])
  return (
    <WhiteBox header='Individuals.PersonalData'>
      <Row>
        <Col sm='12' lg='6'>
          <FormRow label='Individuals.IndividualStatus' name='status' inputType='lookup' dataSource={context.cache.getPersonStatuses} clientSide isCodeList required />
          <FormRow label='Individuals.Name' name='firstName' required inputProps={{ maxLength: 100 }} />
          <FormRow label='Individuals.Surname' name='surname' required={isNullOrWhiteSpace(fatherName) ||
                                                                        isNullOrWhiteSpace(grandfatherName) ||
                                                                        isNullOrWhiteSpace(greatGrandfatherName) ||
                                                                        isNullOrWhiteSpace(motherName) ||
                                                                        isNullOrWhiteSpace(motherFatherName) ||
                                                                        isNullOrWhiteSpace(motherGrandfatherName)} inputProps={{ maxLength: 100 }} />
          <FormRow label='Individuals.FatherName' name='fatherName' required={isNullOrWhiteSpace(surname)} inputProps={{ maxLength: 100 }} />
          <FormRow label='Individuals.GrandfatherName' name='grandfatherName' required={isNullOrWhiteSpace(surname)} inputProps={{ maxLength: 100 }} />
          <FormRow label='Individuals.GreatGrandfatherName' name='greatGrandfatherName' required={isNullOrWhiteSpace(surname)} inputProps={{ maxLength: 100 }} />
          <FormRow label='Individuals.MotherName' name='motherName' required={isNullOrWhiteSpace(surname)} inputProps={{ maxLength: 100 }} />
        </Col>
        <Col sm='12' lg='6'>
          <FormRow label='Individuals.MotherFatherName' name='motherFatherName' required={isNullOrWhiteSpace(surname)} inputProps={{ maxLength: 100 }} />
          <FormRow label='Individuals.MotherGrandfatherName' name='motherGrandfatherName' required={isNullOrWhiteSpace(surname)} inputProps={{ maxLength: 100 }} />
          <FormRow label='Individuals.Gender' name='gender' inputType='lookup' dataSource={context.cache.getGenders} clientSide isCodeList />
          <FormRow label='Individuals.BirthDate' name='birthDate' inputType='date' required />
          <FormRow label='Individuals.BirthPlace' name='birthPlace' inputProps={{ maxLength: 100 }} />
          <FormRow label='Individuals.Nationality' name='nationality' inputType='lookup' dataSource={context.cache.getCountries} clientSide isCodeList required />
          <FormRow label='Individuals.BankExperience' name='bankExperience' inputType='nullableboolean' />
        </Col>
      </Row>
    </WhiteBox>
  )
}

export {
  PersonalData
}



// WEBPACK FOOTER //
// ./src/components/demographics/personalData.js